var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditIconBlue({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "11px",
    height: "11px",
    viewBox: "0 0 11 11",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "6EBCA0B5-D271-44C6-BD00-37FC673E28DC") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Edit-Add-On-Access",
    transform: "translate(-1234.000000, -146.000000)",
    fill: "#4F7AB3",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-10",
    transform: "translate(1234.247714, 145.681719)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Edit-Icon-Blue",
    transform: "translate(0.000000, 0.964866)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.24869973,1.66887117 L8.29288819,3.71304064 L3.1184827,8.88744613 L1.07545323,6.84327666 L6.24869973,1.66887117 Z M9.84403185,1.17586436 L8.93240246,0.264234966 C8.58008917,-0.0880783222 8.0080052,-0.0880783222 7.65449492,0.264234966 L6.78124512,1.13748477 L8.82543358,3.18167323 L9.84403185,2.16307496 C10.117287,1.88980084 10.117287,1.44911948 9.84403185,1.17586436 Z M0.00568849417,9.71652139 C-0.0315131139,9.88394763 0.119649294,10.03397 0.28709453,9.99325348 L2.56499953,9.4409483 L0.521970056,7.39677883 L0.00568849417,9.71652139 Z",
    id: "Shape"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIconBlue);
export default __webpack_public_path__ + "static/media/editIconBlue.709f18bc7e0d749b9cf958ba02e89d7b.svg";
export { ForwardRef as ReactComponent };